import { components as c } from "@/components";
import EducationFormFields from "@/features/events/features/educations/EducationFormFields";
import { zodResolver } from "@hookform/resolvers/zod";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useForm } from "react-hook-form";
import * as z from "zod";
import { useEducationMutation } from "@/features/events/features/educations/api/upsertEducation";
import { useDiaryByIdQuery } from "@/features/diaries";

// Dedicated schema for education form
const educationFormSchema = z.object({
    education_id: z.string().uuid(),
    event_id: z.string().uuid(),
    education_name: z.string().min(1, "Please provide a name for this consultation"),
    education_description: z.string().min(1, "Please describe what was discussed or taught"),
    educated_by: z.string().uuid("Please select who provided the consultation"),
});

type EducationFormValues = z.infer<typeof educationFormSchema>;

const EducationFormFieldsPage = () => {
    const { eventId, diaryId, educationId } = Route.useParams();

    const { data: diary } = useDiaryByIdQuery(diaryId);

    const navigate = useNavigate();

    const { mutate: upsertEducation } = useEducationMutation({ diaryId });

    const form = useForm<EducationFormValues>({
        resolver: zodResolver(educationFormSchema),
        defaultValues: {
            event_id: eventId,
            education_id: educationId,
            education_name: "",
            education_description: "",
            educated_by: undefined,
        },
    });

    const handleNext = (formData: EducationFormValues) => {
        upsertEducation(formData);
        navigate({
            to: "/templates/diary/$diaryId/events/$eventId/complete",
            params: { diaryId, eventId },
        });
    };

    const handlePrevious = () => {
        navigate({ to: "/templates/diary/$templateId/events" });
    };

    return (
        <c.ui.Form {...form}>
            <form onSubmit={form.handleSubmit(handleNext)} className="space-y-6">
                <EducationFormFields organisationId={diary?.organisation_id as string} />

                {/* Navigation Buttons */}
                <div className="flex justify-between gap-4 mt-8">
                    <c.fc.BackButton
                        type="button"
                        variant="outline"
                        label="Previous"
                        onClick={handlePrevious}
                        className="w-auto"
                    />

                    <c.fc.NextButton />
                </div>
            </form>
        </c.ui.Form>
    );
};

export const Route = createFileRoute("/_app/templates/diary/$diaryId/events/$eventId/education/$educationId/")({
    component: EducationFormFieldsPage,
});
